import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Auth tokens live in httpOnly cookies set by the backend. We rely on
// `withCredentials: true` so the browser sends the cookie automatically.
// No tokens are ever placed in localStorage (avoids XSS exfiltration).
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Global toast for the platform LLM budget being exceeded so users always
// see ONE clear, actionable message instead of generic broken UI.
let _budgetToastAt = 0;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const detail = err.response?.data?.detail;
    if (status === 503 && typeof detail === "string" && /budget|llm/i.test(detail)) {
      const now = Date.now();
      if (now - _budgetToastAt > 5000) {
        _budgetToastAt = now;
        toast.error("AI temporarily unavailable", {
          description: "The Universal LLM key has hit its budget. Top up at Profile → Universal Key → Add Balance.",
          duration: 8000,
        });
      }
    }
    return Promise.reject(err);
  }
);

export default api;
